import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { jsPDF } from "jspdf";
import { AES, enc } from 'crypto-js';
import { ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-instalaciones',
  templateUrl: './instalaciones.component.html',
  styleUrls: ['./instalaciones.component.scss']
})
export class InstalacionesComponent implements OnInit {

  @ViewChild('dt') dt: Table | undefined;

  usuario: any;
  clientes: any[];
  guardias: any[];
  guardiasFiltrados: any[];
  guardiasAsignados: any[] = [];
  instalaciones: any[];
  instalacionesFiltradas: any[] = []
  estaEditando: boolean = false;
  modoCreaEdita: boolean = false;
  formulario: FormGroup;

  creaEditaQR: boolean = false
  puntosQR: any[] = []

  creaEditaNFC: boolean = false
  muestraEliminados: boolean = false
  puntosNFC: any[] = []
  codigoTarjeta: string;                // Código de la tarjeta NFC que se está agregando

  ideditando: string;
  nombreInstalacion: string

  buscandoTexto: string // Es el texto del buscador
  empresas: any[] = []

  esCCZ: boolean = false;
  actualizandoVersiones: boolean = false;

  campoFiltro: string = '';
  opcionesFiltro: any[] = [
    { label: 'Todos los campos', value: '' },
    { label: 'Versión CG', value: 'VersionApp_CG' },
    { label: 'Versión Accesos', value: 'VersionApp_Accesos' },
  ];

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    if (this.usuario.Email == 'ccerdaz@gmail.com' || this.usuario.Email == 'fabiancerdac@gmail.com')
      this.esCCZ = true;

    this.formulario = this.formBuilder.group({
      _id: '',
      _cliente: ['', Validators.required],
      Nombre: ['', Validators.required],
      Direccion: '',
      FonoAlertas: '',
      CorreoAlertas: '',
      Habilitado: '',
      Codigo: [{ value: '', disabled: true }],
      createdAt: '',
      updatedAt: '',
      FechaCreacion: '',
    });

    //this.muestraEliminados = false


  }

  async ngOnInit(): Promise<void> {
    await this.getEmpresas()
    this.getClientes();
    this.getInstalaciones();

    this.activatedRoute.params.subscribe(params => {
      let id = params['id'];
      console.log('id', id);

      if (id) {
        const empresa = this.empresas.find(e => e._id == id);
        this.buscandoTexto = empresa.NombreEmpresa
      }
    })
    console.log('buscandoTexto', this.buscandoTexto);
    // Solo aplicar filtro si hay texto de búsqueda
    if (this.buscandoTexto && this.dt) {
      this.aplicarFiltro(this.buscandoTexto);
    }

  }

  aplicarFiltro(valor: string) {
    if (!this.dt) return;
    if (this.campoFiltro) {
      this.dt.filters = {};
      this.dt.filter(valor, this.campoFiltro, 'contains');
    } else {
      this.dt.filters = {};
      this.dt.filterGlobal(valor || '', 'contains');
    }
  }

  cambiaCampoFiltro() {
    if (this.dt) {
      this.dt.filters = {};
    }
    this.aplicarFiltro(this.buscandoTexto || '');
  }

  async getEmpresas(): Promise<void> {
    console.log('getEmpresas');

    this.empresas = await this.http.getEmpresaService();

    console.log('empresas', this.empresas);
  }

  nuevo() {
    console.log('pasṕ por nuevo');

    this.estaEditando = false
    this.modoCreaEdita = true
    this.formulario.controls.Codigo.setValue('(por  asignar)')
    console.log('this.estaEditando', this.estaEditando);
  }

  liberarCodigo() {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, liberar código',
      accept: () => {

        // Método para hacer updatre y dejar Código=null
        this.http.liberarCodigoService(this.ideditando).subscribe((data: any) => {
          this.liberado = true

          this.getInstalaciones()

          this.messageService.add({
            severity: 'success',
            summary: 'Listo!',
            detail: 'El código ha sido liberado'
          });
        })


      },
      reject: () => {
        return;
      }
    });
  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);

    const yaEstaEliminado = this.instalaciones.find(e => e._id == id).Eliminado
    console.log('yaEstaEliminado', yaEstaEliminado);

    let eliminacionTotal = false

    let message = 'Estás seguro?'
    if (yaEstaEliminado) {
      message = 'La instalación ya está eliminada. Si continúa se eliminará definitivamente. Estás seguro?'
      eliminacionTotal = true
    }
    this.confirmationService.confirm({
      target: event.target,
      message: message,
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteInstalacionService(id, eliminacionTotal)
          .subscribe((data: any) => {
            console.log(data);
            this.getInstalaciones();

            this.messageService.add({
              severity: "info",
              summary: "Eliminado!",
              detail: data  // Devuelve la cantidad de instalaciones
            });
          })
      },
      reject: () => {
        return;
      }
    });

  }

  guardar(_formValue) {

    let formValue = JSON.parse(JSON.stringify(_formValue))
    // formValue.Empresa = this.usuario.Empresa._id
    // formValue.Cliente = formValue._cliente

    // formValue.Guardias = this.guardiasAsignados

    console.log('formValue', formValue);

    if (this.estaEditando) {

      this.http.updateInstalacionService(formValue).subscribe((data: any) => {
        console.log('data', data);
        this.getInstalaciones()
        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: 'Registro editado'
        });

        this.modoCreaEdita = false;
        this.estaEditando = false;

        this.limpiaFormulario()
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
      })

      return;
    }

    this.http.newInstalacionService(formValue).subscribe((data: any) => {
      console.log('data', data);
      this.getInstalaciones()
      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: data  // Le muestro la cantidad de instalaciones que tiene
      });

      this.modoCreaEdita = false;
      this.limpiaFormulario()
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    })

  }

  async getClientes(): Promise<void> {
    this.clientes = await this.http.getclientesbyEmpresaService(this.usuario.Empresa._id);
    console.log('clientes', this.clientes);
  }

  cambiaActivo() {
    console.log('cambiaActivo');
    //if (this.muestraEliminados)
    //this.instalacionesFiltradas = this.instalaciones.filter(e => e.Eliminado == true)
    //else
    //this.instalacionesFiltradas = this.instalaciones.filter(e => e.Eliminado == !this.muestraEliminados && e.Habilitado == this.muestraEliminados)
    this.instalacionesFiltradas = this.instalaciones.filter(e => e.Eliminado == this.muestraEliminados)

    // Preservar el filtro de búsqueda
    setTimeout(() => {
      if (this.buscandoTexto && this.dt) {
        this.aplicarFiltro(this.buscandoTexto);
      }
    }, 0);

  }

  async getInstalaciones(): Promise<void> {
    this.instalaciones = await this.http.getallinstalacionesService();
    console.log('this.instalaciones', this.instalaciones);

    // Descarta las instalaciones de Tecnosinergia
    this.instalaciones = this.instalaciones.filter(e => e.Empresa.EmpresaMaster == false)

    // Descarta las instalaciones de Mariana
    this.instalaciones = this.instalaciones.filter(e => e.Empresa.NombreEmpresa != 'MARIANA YANEZ')
    console.log('this.instalaciones', this.instalaciones);

    this.instalacionesFiltradas = this.instalaciones.filter(e => e.Eliminado == this.muestraEliminados)

    for (let i = 0; i < this.instalacionesFiltradas.length; i++) {
      const element = this.instalacionesFiltradas[i];
      const now = new Date();

      // Para poder filtrar por la palabra "pruaba" en el buscador
      if (element.EnModoPrueba) {
        element.prueba = 'En Prueba'
        if (now > new Date(element.FechaCreacion)) {
          element.vencido = 'Vencido'
        }

      }

    }

    // Aplicar filtro solo si existe texto de búsqueda y la tabla está inicializada
    setTimeout(() => {
      if (this.buscandoTexto && this.dt) {
        this.aplicarFiltro(this.buscandoTexto);
      }
    }, 0);

    this.ngZone.run(() => { })

  }

  copyToClipboard(codigo) {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = codigo;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.messageService.add({
      severity: 'info',
      summary: 'Código',
      detail: 'Copiado al portapapeles!',
      key: 'copyToClipboard'
    });

  }

  liberado: boolean = false
  abreModaledita(id) {
    console.log('id:', id);
    this.ideditando = id

    this.liberado = false

    this.estaEditando = true
    this.modoCreaEdita = true
    let index = this.instalaciones.findIndex(e => e._id == id)
    let instalacion = this.instalaciones[index]

    instalacion.createdAt = new Date(instalacion.createdAt)
    instalacion.updatedAt = new Date(instalacion.updatedAt)

    if (instalacion.FechaCreacion)
      instalacion.FechaCreacion = new Date(instalacion.FechaCreacion)

    instalacion._cliente = instalacion.Cliente._id
    console.log('instalacion', instalacion);

    if (instalacion.UUID == null)
      this.liberado = true

    this.formulario.patchValue(instalacion)

  }

  enviarondainmediata(id) {
    console.log('enviarondainmediata');

    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, enviar',
      accept: () => {
        this.http.rondaInmediataService(id).subscribe((data: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Listo!',
            detail: 'Ronda enviada'
          });

        })
      },
      reject: () => {
        return;
      }
    });


  }

  limpiaFormulario() {
    this.formulario.reset()
    this.modoCreaEdita = false
    this.creaEditaQR = false
    this.estaEditando = false
    this.guardiasAsignados = []
    this.puntosQR = []
    this.puntosNFC = []
    this.creaEditaNFC = false

    console.log('buscandoTexto', this.buscandoTexto);
    // IMPORTANTE: NO eliminar esta línea, pero asegurarse de que buscandoTexto mantenga su valor
    // Solo aplicar el filtro si hay texto de búsqueda
    setTimeout(() => {
      if (this.buscandoTexto && this.dt) {
        console.log('Aplicando filtro con texto:', this.buscandoTexto);
        this.aplicarFiltro(this.buscandoTexto);
      }
    }, 100); // Pequeño delay para asegurar que la tabla esté lista
  }

  // 5. Método adicional para limpiar solo la búsqueda si es necesario
  limpiarBusqueda() {
    this.buscandoTexto = '';
    if (this.dt) {
      this.dt.filters = {};
      this.dt.filterGlobal('', 'contains');
    }
  }

  actualizarVersionesApp() {
    this.actualizandoVersiones = true;
    this.http.actualizarVersionesAppService().subscribe((data: any) => {
      this.actualizandoVersiones = false;
      this.getInstalaciones();
      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: 'Versiones actualizadas'
      });
    }, err => {
      this.actualizandoVersiones = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    });
  }
}